import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';

import { environment } from 'src/environments/environment.local';
import * as formatDataHelpers from '../helpers/format-subscription-data.helpers';
import { FamilyOptionPlan, Plan } from '../models/plan.model';
import { SubscriptionPlan } from 'app/models/subscrition-plan.model';
import { CurrencyType } from 'app/services/gift-cards-plans.service';

@Injectable({ providedIn: 'root' })
export class PlansApi {
  private readonly plansUrl = environment.api.dashboard.plans;

  constructor(private http: HttpClient) { }

  getPlans$(
    currency: string
  ): Observable<{ plans: Plan[]; familyOptionPlan: FamilyOptionPlan | null }> {
    const params = new HttpParams().set('devise', currency);
    return this.http.get(this.plansUrl, { params }).pipe(
      map((data: any) => {
        return formatDataHelpers.convertApiDataToPlansAndFamilyOptionPlan(
          data['data']
        );
      })
    );
  };


  getAllPlans(currency: CurrencyType): Observable<SubscriptionPlan[]> {
    const params = new HttpParams().set('currency', currency);
    return this.http.get<{ data: SubscriptionPlan[] }>(environment.api.dashboard.plans, { params }).pipe(
      map((res: { data: SubscriptionPlan[] }) => res.data)
    )
  }
}
